import { RouteRecordRaw } from 'vue-router'

/**
 * Маршруты админки платежей.
 *
 * Подключение в router/index.ts: ОБЯЗАТЕЛЬНО в children корневого маршрута с Layout
 * (на верхнем уровне массива routes страницы рендерятся без шаблона: нет меню и заголовка):
 *   children: [ ...существующие маршруты, ...paymentsRoutes ]
 *
 * sidebar: 'user' включает левое меню, как у остальных разделов админки (пункты меню добавляются там же).
 * crumbs: хлебные крошки раздела (ссылка «Платежи» и «Главная» добавляются обёрткой Payments.vue).
 * Доступ ограничивает бэкенд (is_admin); при отказе запрос вернёт 403.
 */
type Crumb = { title: string; to?: { name: string } }

const meta = (
  title: string,
  crumbs: Crumb[],
  extra: Record<string, unknown> = {}
) => ({
  title,
  name: title,
  sidebar: 'user',
  asideEnabled: true,
  asidePrimaryDisabled: true,
  crumbs,
  ...extra,
})

const orders: Crumb = { title: 'Заказы', to: { name: 'payments-orders' } }

const paymentsRoutes: Array<RouteRecordRaw> = [
  {
    path: '/payments',
    name: 'payments',
    redirect: {
      name: 'payments-documents',
      query: { type: 'invoice', status: 'issued' },
    },
    meta: meta('Платежи', []),
    component: () => import('@/view/pages/payments/Payments.vue'),
    children: [
      {
        path: '/payments/orders',
        name: 'payments-orders',
        meta: meta('Заказы', [{ title: 'Заказы' }]),
        component: () => import('@/view/pages/payments/OrdersList.vue'),
      },
      {
        path: '/payments/orders/:id',
        name: 'payments-orders-view',
        meta: meta('Заказ', [orders, { title: 'Заказ' }], { buttonBack: true }),
        component: () => import('@/view/pages/payments/OrderView.vue'),
      },
      {
        path: '/payments/list',
        name: 'payments-list',
        meta: meta('Платёжные операции', [{ title: 'Платёжные операции' }]),
        component: () => import('@/view/pages/payments/PaymentsList.vue'),
      },
      {
        path: '/payments/documents',
        name: 'payments-documents',
        meta: meta('Счета и акты', [{ title: 'Счета и акты' }]),
        component: () => import('@/view/pages/payments/DocumentsList.vue'),
      },
      {
        path: '/payments/incidents',
        name: 'payments-incidents',
        meta: meta('Инциденты', [{ title: 'Инциденты' }]),
        component: () => import('@/view/pages/payments/IncidentsList.vue'),
      },
      {
        path: '/payments/products',
        name: 'payments-products',
        meta: meta('Товары', [{ title: 'Товары' }]),
        component: () => import('@/view/pages/payments/ProductsList.vue'),
      },
      {
        path: '/payments/audit',
        name: 'payments-audit',
        meta: meta('Журнал действий', [{ title: 'Журнал действий' }]),
        component: () => import('@/view/pages/payments/PaymentsAudit.vue'),
      },
    ],
  },
]

export default paymentsRoutes
